import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { shippingMessageData as modal } from '../../mock/globalAPI.tsx';
import DetailsModal from '../global/DetailsModal';

class ShippingMessage extends Component {
  render() {
    const { shippingEstimate } = this.props;
    const {
      teaserIcon, popUpCopy, header, asset,
    } = modal;
    return (
      <span className="pdp-details-shipping-message">
        <DetailsModal
          teaserIcon={teaserIcon}
          shippingEstimate={shippingEstimate}
          popUpCopy={popUpCopy}
          header={header}
          asset={asset}
        />
      </span>
    );
  }
}

ShippingMessage.propTypes = {
  shippingEstimate: PropTypes.string,
};

export default ShippingMessage;
